import { Article } from '~/types';

export function resolveArticleComponent(article: Article.Model) {
  switch (article.type) {
    case 'video':
      return 'VideoType';
    default:
      return 'DefaultType';
  }
}

export const resolveArticleTypeLabel = (type: Article.ArticleType) => {
  switch (type) {
    case 'gallery':
      return 'Gallery';
    case 'default':
      return 'Article';
    case 'video':
      return 'Video';
  }
};
